import { NumberFormatter } from "@internationalized/number"

import { UNKNOWN_PLATE_PREFIX } from "./etc"
import {
  COUNTRY_DIAL_CODES,
  CountryIdentifiers,
  getCountryCodesFromPhoneNumber,
  US_LOCALE,
} from "./localization"

// export const normalizePhoneNumber = (value: string) => {
//   if (!value) {
//     return value
//   }
//   let numerals = value.replace(/[^\d]/g, "")

//   // special cases for deletion
//   if (value.length - numerals.length === 2) {
//     numerals = numerals.slice(0, -1)
//   }

//   // decorating input in the National Format
//   return numerals.length === 0
//     ? ""
//     : numerals.length <= 3
//       ? `(${numerals.substring(0, 3)}) `
//       : numerals.length <= 6
//         ? `(${numerals.substring(0, 3)}) ${numerals.substring(3, 6)}`
//         : `(${numerals.substring(0, 3)}) ${numerals.substring(3, 6)}-${numerals.substring(6)}`
// }
export function normalizePhoneNumber(input: string) {
  const numbers = stripNonNumerics(input)

  switch (numbers.length) {
    case 0:
    case 1:
    case 2:
    case 3:
      return numbers // Just display as entered
    case 4:
    case 5:
    case 6:
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}` // Add a dash after first 3 digits
    case 7:
    case 8:
    case 9:
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}` // US format
    case 10:
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}` // Standard 10-digit format
    case 11:
      return `${numbers[0]} ${numbers.slice(1, 4)}-${numbers.slice(4, 7)}-${numbers.slice(7)}` // US-style with country code
    case 12:
    case 13:
    case 14:
      return `${numbers.slice(0, 2)} ${numbers.slice(2, 5)} ${numbers.slice(5, 8)} ${numbers.slice(8)}` // Simple international formatting
    default:
      return numbers.slice(0, 14) // No assumptions, just return as-is
  }
}

// To accomododate legacy phone number inputs
export function removeUSCountryCode(input: string) {
  if (input.startsWith("+")) {
    const countryCode = getCountryCodesFromPhoneNumber(input)
    console.log("INTERNATIONAL", countryCode, input)
    if (countryCode.includes("US")) {
      const dialCode = COUNTRY_DIAL_CODES.get(countryCode[0])
      const foo = input.slice(dialCode?.length || 0)
      console.log("FOO: ", foo)
      return foo
    }
  }

  return stripNonNumerics(input)
}

export function normalizePhoneNumberWithCountryCode(
  input: string,
  countryCode: CountryIdentifiers
): string {
  const numbers = stripNonNumerics(input)

  // Handle North American countries (US, Canada, Mexico) with special formatting
  if (["US", "CA", "MX"].includes(countryCode)) {
    switch (numbers.length) {
      case 0:
        return ""
      case 1:
      case 2:
      case 3:
        return numbers
      case 4:
      case 5:
      case 6:
        return `${numbers.slice(0, 3)}-${numbers.slice(3)}`
      case 7:
      case 8:
      case 9:
      case 10:
        return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6)}`
      default:
        // For longer North American numbers, extend the format
        return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}${numbers.length > 10 ? +numbers.slice(10) : ""}`
    }
  }

  // For all other countries, display numbers as-is without spaces
  return numbers
}

export const normalizeLongStringOfNumbers = (value: string) => {
  const groups = value.match(/\d{1,3}/g) || []
  if (groups.length > 1 && groups[groups.length - 1].length < 3) {
    const lastGroup = groups.pop()
    groups[groups.length - 1] += lastGroup
  }
  return groups.join("-")
}

export const stripNonNumerics = (value: string) => {
  return value.replace(/\D/g, "")
}

export const stripNonPhoneCharacters = (value: string) => {
  return value.replace(/[^\d+]/g, "")
}

export const prettyCurrencyNumber = (amount: number) => {
  const currenyFormatter = new NumberFormatter(US_LOCALE, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: !amount.toString().split(".")[1]?.length
      ? 0
      : undefined,
    maximumFractionDigits: 2,
  })

  return currenyFormatter.format(amount)
}

export const stripNonAlphaNumerics = (value: string) => {
  return value.replace(/[^a-z0-9]/gi, "")
}

// Normalizes what the user enters
export const normalizeLicensePlate = (value: string) => {
  return stripNonAlphaNumerics(value).toUpperCase()
}

// Normalizes what is returned by the api. Some of them are prefixed with "UNKNOWN"
export const normalizedAPILicensePlate = (plate?: string | null) => {
  if (!plate || plate.startsWith(UNKNOWN_PLATE_PREFIX)) {
    return "—"
  }
  return plate
}
